import React from 'react';

import classNames from 'classnames';
import { injectStoresV2 } from '../../../stores/injectStoresV2';
import { RouteLocation } from '../../../stores/routes/createRoute';
import { BILoggerStore } from '../../../stores/BILoggerStore';
import { SeoLink } from '../../SeoLink/SeoLink';
import { megaMenuDropdownSectionDataHooks } from './MegaMenuDropdownSection.dataHooks';

import s from './MegaMenuDropdownSection.scss';

export interface MegaMenuDropdownItem {
  id: string;
  label: string;
  link: RouteLocation;
  items?: MegaMenuDropdownItem[];
}

interface MegaMenuDropdownSectionProps extends MegaMenuDropdownItem {
  groupLabel: string;
  biLoggerStore: BILoggerStore;
  onItemClick?: (e: React.SyntheticEvent) => void;
  dataHook?: string;
  isNewUi?: boolean;
}

const MegaMenuDropdownSectionCmp: React.FC<MegaMenuDropdownSectionProps> = ({
  id: sectionId,
  label,
  link,
  groupLabel,
  onItemClick,
  biLoggerStore,
  dataHook,
  isNewUi,
}) => (
  <li className={classNames(s.section, s.noSubcats)} data-hook={dataHook}>
    <SeoLink
      className={classNames(s.noSubcatsLink, { [s.newHeadingLinkUi]: isNewUi })}
      to={link}
      dataHook={megaMenuDropdownSectionDataHooks.headingItemLink()}
      onClick={(event) => {
        biLoggerStore.logCategorySelect({ clickSource: 'header', category: sectionId, categoryGroup: groupLabel });
        onItemClick && onItemClick(event);
      }}
      data-bi-element="category"
      data-bi-element-value={sectionId}
    >
      {label}
    </SeoLink>
  </li>
);

export const MegaMenuDropdownSection = injectStoresV2('biLoggerStore')(MegaMenuDropdownSectionCmp);
